/**
 * 🔄 MISE À JOUR DU SITE PENDANT LA VISITE
 * Chaque compilation renomme les fichiers du site : un onglet ouvert avant une mise à jour demande alors
 * des fichiers qui n'existent plus. On le détecte (le fichier principal annoncé par le serveur a changé)
 * et on recharge la page une seule fois, sans rien demander au visiteur.
 */

const RELOAD_KEY = 'site_update_reload_at';
const MAIN_SCRIPT = /\/static\/js\/main\.[a-z0-9]+\.js/i;

const currentMainScript = () => {
  const script = [...document.querySelectorAll('script[src]')].find(s => MAIN_SCRIPT.test(s.src));
  return script ? script.src.match(MAIN_SCRIPT)[0] : null;
};

/** Le serveur annonce-t-il une version plus récente que celle chargée dans l'onglet ? */
export async function siteWasUpdated() {
  if (typeof window === 'undefined' || navigator.onLine === false) return false;
  const loaded = currentMainScript();
  if (!loaded) return false;
  try {
    const response = await fetch(`/?version=${Date.now()}`, { cache: 'no-store' });
    if (!response.ok) return false;
    const served = (await response.text()).match(MAIN_SCRIPT)?.[0];
    return Boolean(served && served !== loaded);
  } catch {
    return false; // pas de réseau : ce n'est pas une mise à jour
  }
}

/**
 * Recharge la page si le site a été mis à jour (au plus une fois par minute, pour éviter toute boucle).
 * @returns {Promise<boolean>} true si le rechargement est lancé
 */
export async function reloadIfSiteUpdated() {
  let last = 0;
  try { last = Number(sessionStorage.getItem(RELOAD_KEY)) || 0; } catch { /* stockage indisponible */ }
  if (Date.now() - last < 60000) return false;
  if (!(await siteWasUpdated())) return false;
  try { sessionStorage.setItem(RELOAD_KEY, String(Date.now())); } catch { /* stockage indisponible */ }
  window.location.reload();
  return true;
}
